"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6209],{

/***/ 16209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BannerImage1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/Banner1.jpeg
/* harmony default export */ var Banner1 = ({"src":"/_next/static/media/Banner1.d0a14794.jpeg","height":694,"width":3661,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAaEAACAgMAAAAAAAAAAAAAAAAAAQMSITJh/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABcRAAMBAAAAAAAAAAAAAAAAAAACMQP/2gAMAwEAAhEDEQA/AK7StLjWeNLisgAEzglqf//Z","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/Banner1Lowres.jpeg
/* harmony default export */ var Banner1Lowres = ({"src":"/_next/static/media/Banner1Lowres.bbe7dbc4.jpeg","height":133,"width":700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAEAAgIDAAAAAAAAAAAAAAABAAMCERIiYf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAXEQADAQAAAAAAAAAAAAAAAAAAATEC/9oADAMBAAIRAxEAPwCzmBZdoOt9Zj4ciIiExBTp/9k=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/artifacts/images/homepage/MobileBanner1.jpeg
/* harmony default export */ var MobileBanner1 = ({"src":"/_next/static/media/MobileBanner1.ed239e28.jpeg","height":697,"width":2465,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAACAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAADAAEFAAAAAAAAAAAAAAAAAQIRAwQhIjH/xAAUAQEAAAAAAAAAAAAAAAAAAAAE/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAIxQf/aAAwDAQACEQMRAD8Aq4V1v5pZmdHqn4uAAETRTU//2Q==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/BannerImage1.tsx








function BannerImage1() {
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var handleLoad = function() {
        setLoaded(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        children: mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                position: "relative",
                width: "100%",
                height: "188px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                objectPosition: "center",
                src: MobileBanner1,
                layout: "fill",
                objectFit: "cover",
                placeholder: "blur",
                priority: true,
                alt: ""
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: loaded ? Banner1 : Banner1Lowres,
            quality: 100,
            onLoadingComplete: handleLoad,
            placeholder: "blur",
            objectFit: "cover",
            alt: "",
            blurDataURL: Banner1Lowres.src
        })
    });
}


/***/ })

}]);